import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Nav from '../components-public/Nav'
import Footer from '../components-public/Footer'
import { usePublicCases } from '../hooks/useCases'

export default function CaseListPage() {
  const { cases, loading } = usePublicCases(20)

  const badgeLabel = (c) => {
    const base = c.sector === 'public' ? 'Setor Público' : 'Setor Privado'
    return c.sub_sector ? `${base} · ${c.sub_sector}` : base
  }
  const badgeClass = (c) => c.sector === 'public' ? 'pub' : 'priv'

  return (
    <>
      <Helmet>
        <title>Cases de Sucesso | Orken Tecnologia</title>
        <meta name="description" content="Conheça os cases de sucesso da Orken Tecnologia em gestão pública e privada." />
      </Helmet>
      <Nav />
      <main style={{ paddingTop: 104 }}>
        <section className="section">
          <div className="section-inner">
            <div className="section-eyebrow">Cases de sucesso</div>
            <h1 className="section-title">Resultados reais que construímos juntos</h1>

            {loading && (
              <div className="cases-grid">
                {[1,2,3,4].map(i => (
                  <div key={i} className="case-card">
                    <div style={{ height: 18, width: '40%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 16 }} />
                    <div style={{ height: 24, width: '70%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 8 }} />
                    <div style={{ height: 16, width: '50%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 16 }} />
                    <div style={{ height: 14, width: '100%', background: 'var(--bg-2)', borderRadius: 4 }} />
                  </div>
                ))}
              </div>
            )}

            <div className="cases-grid">
              {cases.map((c) => (
                <Link to={`/cases/${c.slug}`} key={c.id} style={{ textDecoration: 'none' }}>
                  <div className="case-card">
                    <span className={`case-sector-badge ${badgeClass(c)}`}>{badgeLabel(c)}</span>
                    <h3>{c.title}</h3>
                    <p className="case-client">{c.client}</p>
                    <p className="case-desc">{c.description}</p>
                    <div className="case-result">{c.featured_result}</div>
                    <div className="case-tags">
                      {(c.tags || []).map(t => <span className="case-tag" key={t}>{t}</span>)}
                    </div>
                  </div>
                </Link>
              ))}
              {!loading && cases.length === 0 && (
                <p style={{ color: 'var(--text-muted)' }}>Nenhum case publicado ainda.</p>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}
